<template>            
    <div :class="'item video_item ' + (item.restricted ? 'restricted' : '')"  @mouseover="item_hover(item.id)">
        <label v-if="item.restricted === true" class="lbl_restricted">מוגבל</label>
                    <i v-if="item.episode.is_premium == 1 && !$store.user.is_active" class="fas fa-lock"></i>

                <label v-if="item.sticker > 0" class="lbl_sticker" ><span v-text="$store.state.stickers[item.sticker].name"></span></label>

        <div v-on:click="isHidden = !isHidden"  v-if="item.restricted === true" class="show_why_block">
          <div  v-if="!isHidden" >
            <span>תוכן זה חסום בשל הגדרות הפרופיל שלך  </span>
            <!--<div class="sdf" v-for="rest in restrictions_list" :key="rest.id">
              <span v-text="rest.name"></span>
            </div>-->

            
          </div>
        </div> 
        <div class="initial">
        <router-link :to="url">
            <div class="pic" v-lazy:background-image="item.pic_thumb_parsed">
                <div class="user_duration"><span :style="'width:' + item.user_duration_perc + '%'"></span></div>
            </div>
            <div class="details">
                <h3>{{ item.title }}</h3>
            </div>
        </router-link>
        </div>

        <div class="onhover" @click="isHidden = !isHidden">
        <router-link :to="url" class="overlay_link"></router-link>
        <div class="pic" :style="'background-image:url(' + item.pic_thumb_parsed + ')'"></div>

        <div class="promo_video" :id="'videopromo_' + item.id" v-if="!isNull(item.video_promo) && item.restricted === false">
            <video  muted preload="none">
            <source :src="item.video_promo" type="video/mp4">
            </video>

        </div>

        <div class="details"  v-if="isHidden">
            <h3>{{ item.description }}</h3>
            <div class="props">
                <span v-text="(item.type == 'series' ? 'סדרה' : 'סרט')"></span>
                <span v-if="item.main_category" v-text="item.main_category.name"></span>
                <span v-if="item.seasons != undefined && item.seasons.length > 1">{{ item.seasons.length }} עונות</span>
                <span>{{item.year}}</span>
            </div>
            <router-link class="info_link" :to="'/info/' + item.id">פרטים נוספים</router-link>
            <a v-if="item.is_favorite" class="add_to_fav" @click="remove_from_fav(item.id)">הסרה מרשימת צפייה</a>
            <a v-if="!item.is_favorite && item.restricted === true" class="add_to_fav" @click="add_to_fav(item.id)">הוספה לרשימת צפייה</a>
        </div>

        </div>
    </div>
</template>

<script>

export default {
  props: ["item"],
  data() {
    return {
     isHidden: true,
      url: (this.item.restricted === true ? '' : 
        (this.item.type == 'live' ? '/livePage/' : '/item/')
        + 
      this.item.id
      )
    }
  },
 
  computed: {
     restrictions_list: function () {

        var ret = [];
        var restrictions = JSON.parse(JSON.stringify(this.$store.state.restrictions));

        for (let i in this.item.restriction_ids_parsed)
        {
          for (let z in restrictions)
          {
            if (restrictions[z].id == this.item.restriction_ids_parsed[i]) ret.push(restrictions[z]);
          }
        }

        return ret;
      
    }
  },
  
  methods: {
  
    item_hover(id){
     
      this.item.loadVideo=true;
      
      //alert(4);
      if (!this.isNull(this.item.video_promo)) this.$el.querySelector('#videopromo_' + id + ' video').play();
    }

  },
  created() {
   

  }
}
</script>